import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  constructor(private readonly http: HttpClient) {}
  getSignatureData(): Observable<any> {
    return this.http.get('assets/data/uim-ui/signature.json');
  }
}
